import * as ACTIONS from '../constants/hpsReplaceForm';

const initialState = {
  loading: false,
  error: false,
  success: {
    Code: '',
    CardID: '',
  },
  step: 0,
  patientInformation: {
    mobilePhoneNumber: '',
    dob: '',
  },
};

function hpsReplaceForm (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.HPS_REPLACE.CHANGE_STEP:
    case ACTIONS.SUBMIT_HPS_REPLACE_FORM.INIT:
    case ACTIONS.SUBMIT_HPS_REPLACE_FORM.ERROR:
    case ACTIONS.SUBMIT_HPS_REPLACE_FORM.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.HPS_REPLACE.VERIFY_PATIENT_INFO:
      return {
        ...state,
        patientInformation: {
          ...state.patientInformation,
          ...action.payload,
        },
      };
    case ACTIONS.HPS_REPLACE.CLEAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}

export default hpsReplaceForm;
